import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massDestroySkills } from "../../api/apiSkills";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف جماعي للمهارات (soft delete)
 */
export function useDeleteAllSkills() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteAllSkillsMutate,
        isPending,
    } = useMutation({
        mutationFn: massDestroySkills,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["skills"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete skills");
        },
    });

    return {
        deleteAllSkillsMutate,
        isPending,
    };
}